import { css } from '@emotion/css';
import { Button, Content } from '@volumental/common';
import { type JSX } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  ImageNames,
  useImageSrc,
} from '../../../services/asset-src-controller';
import { uiConfig } from '../../../services/config';
import { ScannerVariant } from '../utils';

const wrapperStyle = css`
  display: block;
  flex-grow: 0;
  flex-shrink: 2;
  flex-basis: auto;
  position: relative;
  height: auto;
`;

const instructionStyle = css`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  font-family: ${uiConfig.styles.fontFamily};
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: 21px;
  color: ${uiConfig.styles.colors.black};
  padding-bottom: 2rem;
  text-align: center;
  height: 3rem;
  padding-top: 1.5rem;
  max-lines: 3;
`;

const imageStyle = css`
  aspect-ratio: 1;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 1rem;
`;

interface InstructionViewProps {
  onClick: () => void;
  scannerVariant: ScannerVariant;
}

export function InstructionView({
  scannerVariant,
  onClick,
}: InstructionViewProps): JSX.Element {
  const { t } = useTranslation();
  const getImage = useImageSrc(scannerVariant);
  return (
    <>
      <Content disableScrollbar>
        <div className={wrapperStyle}>
          <img
            data-cy="onboarding-image"
            src={getImage(ImageNames.PoseImage2)}
            alt={t('imageAlt.instruction')}
            className={imageStyle}
          />
        </div>
        <div className={instructionStyle}>
          <Trans>
            {scannerVariant === ScannerVariant.Assisted
              ? t('instructionAssisted.moveByVideo')
              : t('instruction.moveByVideo')}
          </Trans>
        </div>
      </Content>
      <div style={{ padding: '24px' }}>
        <Button onClick={onClick}>{t('button.ready')}</Button>
      </div>
    </>
  );
}
